import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const TranscricaoContext = createContext();

export function TranscricaoProvider({ children }) {
  const [transcriptions, setTranscriptions] = useState([]);

  // Função para adicionar nova transcrição
  // Aceita objeto { text, isFinal, confidence } ou string (retrocompatibilidade)
  const addTranscription = useCallback((data) => {
    const transcriptionObj = typeof data === 'string'
      ? { text: data, isFinal: true, confidence: 1 }
      : data;

    setTranscriptions(prev => [...prev, {
      text: transcriptionObj.text,
      isFinal: transcriptionObj.isFinal ?? true,
      confidence: transcriptionObj.confidence ?? 1,
      timestamp: transcriptionObj.timestamp || Date.now(),
      id: Date.now() + Math.random() // ID único
    }]);
  }, []);

  // Função para resetar o histórico (debug)
  const resetTranscriptions = useCallback(() => {
    setTranscriptions([]);
  }, []);

  // Última transcrição
  const latestTranscription = useMemo(() =>
    transcriptions[transcriptions.length - 1] || null,
    [transcriptions]
  );

  // Texto da última transcrição
  const latestTranscriptionText = useMemo(() =>
    latestTranscription?.text || '',
    [latestTranscription]
  );

  // Histórico de transcrições (todas) - agora retorna objetos completos
  const transcriptionHistory = useMemo(() =>
    transcriptions,
    [transcriptions]
  );

  // Histórico apenas de textos (para retrocompatibilidade)
  const transcriptionTexts = useMemo(() =>
    transcriptions.map(t => t.text),
    [transcriptions]
  );

  const value = useMemo(() => ({
    transcriptions,
    latestTranscription,
    latestTranscriptionText,
    transcriptionHistory,
    transcriptionTexts,
    hasTranscriptions: transcriptions.length > 0,
    addTranscription,
    resetTranscriptions
  }), [transcriptions, latestTranscription, latestTranscriptionText, transcriptionHistory, transcriptionTexts, addTranscription, resetTranscriptions]);

  return (
    <TranscricaoContext.Provider value={value}>
      {children}
    </TranscricaoContext.Provider>
  );
}

export function useTranscricao() {
  const context = useContext(TranscricaoContext);
  if (!context) {
    throw new Error('useTranscricao deve ser usado dentro de TranscricaoProvider');
  }
  return context;
}
